import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import ImageIcon from "@mui/icons-material/Image";
import WorkIcon from "@mui/icons-material/Work";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import CakeIcon from "@mui/icons-material/Cake";

import "./style.css";
import ActionBarComponentProps from "../caledarPayment/Calendar";

export default function FolderList() {
  let windoWidth = window.innerWidth;

  return (
    <div className="events-container">
      <List
        sx={{ bgcolor: "background.paper" }}
        className="folder-list-container"
      >
        <h1>choose event </h1>
        <ListItem className="folder-list">
          <ListItemAvatar>
            <Avatar>
              <ImageIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Happy Hour" secondary="feb 5, 2022" />
        </ListItem>
        <ListItem className="folder-list">
          <ListItemAvatar>
            <Avatar>
              <WorkIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Meeting night" secondary="Jan 7, 2023" />
        </ListItem>
        <ListItem className="folder-list">
          <ListItemAvatar>
            <Avatar>
              <BeachAccessIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Company Vacation" secondary="July 20, 2023" />
        </ListItem>
        <ListItem className="folder-list">
          <ListItemAvatar>
            <Avatar>
              <BeachAccessIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Family vacation" secondary="Jan 9, 2023" />
        </ListItem>
        <ListItem className="folder-list">
          <ListItemAvatar>
            <Avatar>
              <CakeIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Birthday party" secondary="Jan 14, 2023" />
        </ListItem>
        {windoWidth < 764 &&
        <div className="mobile-date-picker">
              <ActionBarComponentProps />
              </div>
        }
      </List>
      {windoWidth > 764 &&
      <ActionBarComponentProps />
}
    </div>
  );
}
